<template>
  <v-dialog v-model="dialog" persistent sm width="500">
    <v-card flat>
      <v-toolbar class="white--text primary dark">
        <div class="flex items-center w-full justify-between">
          Export PDF
          <div>
            <v-btn text dense small dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </v-toolbar>
      <v-divider />
      <div class="pa-2 flex flex-col space-y-2.5">
        <div class="flex space-x-2.5">
          <v-text-field type="date" hide-details label="Date Start" outlined dense />
          <v-text-field type="date" hide-details label="Date End" outlined dense />
        </div>
        <v-autocomplete v-model="selectedTransferStatus" multiple small-chips deletable-chips hide-details label="Status" outlined
                        dense :items="transferStatuses" />
        <v-autocomplete v-model="selectedStores" multiple small-chips deletable-chips hide-details label="Stores" outlined dense
                        :items="stores" item-value="id" item-text="name" />
        <div class="flex space-x-2.5">
          <v-btn dense dark color="red" :loading="exporting" @click="exportPdf">
            PDF
          </v-btn>
          <v-btn dense dark color="primary" :loading="exporting" @click="exportCsv">
            CSV
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import appAxios from '../../../../extra-functions/axios.extra'
import StoreTransferPdf from '../../../../pdf/store-transfer.pdf'
import { downloadCSV, formatAccounting, getCurrentDateEnUsFormat } from '../../../../lib/utils'

const transferStatuses = [
  'pending',
  'out for delivery',
  'partially delivered',
  'completed',
  'cancelled',
]

export default {
  data() {
    return {
      dialog: false,
      transferStatuses: [...transferStatuses],
      selectedTransferStatus: [...transferStatuses],
      selectedStores: [],
      exporting: false,
      dateStart: null,
    }
  },
  computed: {
    ...mapState({
      stores: state => state.branchLocation.list.filter(listItem =>
        listItem.id !== state.settings.storeId,
      ),
      authToken: state => state.auth.token,
    }),
  },
  created() {
    this.selectedStores = this.stores.map(item => item.id)
  },
  methods: {
    open() {
      this.dialog = true
    },
    async exportPdf() {
      try {
        this.exporting = true
        const params = {
          dateStart: this.dateStart,
          dateEnd: this.dateEnd,
          statuses: [...this.selectedTransferStatus],
          stores: [...this.selectedStores],
        }
        const { data } = await appAxios(this.authToken).get('/store-transfers/export-data', { params })
        const transferData = {
          date_range: data.date_range,
        }
        const items = data.items.map(item => [
          getCurrentDateEnUsFormat(new Date(item.date)),
          item.to_store,
          item.order_no,
          item.status,
          formatAccounting(item.cost_of_transport),
          formatAccounting(item.balance),
          formatAccounting(item.sub_total),
        ])
        const pdf = new StoreTransferPdf()
        pdf.generate(transferData, items)
      } catch (e) {
        console.error(e)
        this.$alertSwalError('oops something went wrong!!!')
      } finally {
        this.exporting = false
      }
    },
    async exportCsv() {
      try {
        this.exporting = true
        const params = {
          dateStart: this.dateStart,
          dateEnd: this.dateEnd,
          statuses: [...this.selectedTransferStatus],
          stores: [...this.selectedStores],
        }
        const { data } = await appAxios(this.authToken).get('/store-transfers/export-data', { params })
        const transferData = {
          date_range: data.date_range,
        }
        const items = data.items.map(item => [
          getCurrentDateEnUsFormat(new Date(item.date)),
          item.to_store,
          item.order_no,
          item.status,
          item.cost_of_transport,
          item.balance,
          item.sub_total,
        ])
        const date = new Date().getTime()
        const headers = [
          [
            'Date',
            'Store',
            'Order No',
            'Status',
            'Cost of Transportation',
            'Balance',
            'Sub',
          ],
        ]
        const csvFilename = `store_transfers_${date}.csv`
        console.log(items.map(e => e.join(',')).join('\n'))
        downloadCSV([...headers, ...items], csvFilename)
      } catch (e) {
        console.error(e)
        this.$alertSwalError('oops something went wrong!!!')
      } finally {
        this.exporting = false
      }
    },
  },
}
</script>
